'use client';

import { usePathname, useSearchParams } from 'next/navigation';

/**
 * Hook to generate search params for a signup URL
 * @param authCheckUrl URL to redirect to after login (default: '/auth-check')
 * @returns URL string for the login page
 */
export function useSignupUrl(authCheckUrl: string = '/auth-check') {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const authCheck = new URL(authCheckUrl, process.env.NEXT_PUBLIC_NEXTAUTH_URL as string);
  authCheck.searchParams.append('reference', searchParams.get('reference') ?? pathname);
  authCheck.searchParams.append('signup', 'true');
  return authCheck.toString();
}
